import Login from '../pages/login';
import NotFound from '../components/NotFound';
import Dashboard from '../pages/dashboard';
import ManageLeads from '../pages/mange-leads';
import ManageAffiliate from '../pages/manage-affiliate';
import AddLead from '../pages/add-lead';
import ForgotPassword from '../pages/forgot-password';
import ResetPassword from '../pages/reset-password';
import DownloadLink from '../pages/download-link';
import AffiliateConfigurationSettings from '../pages/affiliate-configuration-settings';
import ManageUsers from '../pages/manage-users';
import ViewUser from '../pages/view-user';
import ManageRoles from '../pages/manage-roles';
import ViewRole from '../pages/view-role';
import ApiDetails from '../pages/api-details';
import AffiliateKyc from '../pages/affiliate-kyc';
import ChangePassword from '../pages/change-password';
import ComissionReport from '../pages/comission-report';
import ManageOffers from '../pages/manage-offers';
import ConfigureComission from '../pages/configure-comission';
import ContainerRouter from '../components/ContainerRouter';
import AssignedPortfolio from '../Views/Portfolio/AssignedPortfolio';
import UnassignedPortfolio from '../Views/Portfolio/UnassignedPortfolio';
import PendingPortfolio from '../Views/Portfolio/PendingPortfolio';
import ViewPortfolio from '../Views/Portfolio/ViewPortfolio';
import PendingView from '../Views/Portfolio/ViewPortfolio/PendingView';
import PortfolioDashboard from '../Views/Portfolio/Dashboard/PortfolioDashboard';
// import AdditionalInformation from '../Views/Portfolio/ViewPortfolio/AdditionalInformation';
import ApplicationDetails from '../pages/application-details';
import AddAffiliate from '../pages/add-affiliate';
import OnboardingForm from '../pages/onboarding-form';
import PreApproved from '../Views/Portfolio/PreapprovedPortfolio';
import History from '../Views/Portfolio/History';
import BatchHistory from '../Views/Portfolio/History/BatchHistory';
import NewDashboard from '../Views/Portfolio/NewDashboard';
import MisReport from '../Views/Portfolio/MisReport';
import Fundoutbulkupload from '../Views/Portfolio/fundoutbulkupload';
import ApiListing from '../Views/Portfolio/ApiLogs/ApiListing/ApiListing';
import ApiLogDetails from '../Views/Portfolio/ApiLogs/ApiDetails/ApiLogDetails';
import QueryPending from '../Views/Portfolio/QueryPending';
import AdditionalInfoupload from '../Views/Portfolio/AdditionalInfoUpload/AdditionalInfoupload';
import GlobalSearch from '../Views/Portfolio/GlobalLafSearch/GlobalSearch';
import Home from '../pages/home';
import PoolSearch from '../Views/Portfolio/DA/PoolSearch';
import PoolAssignment from '../Views/Portfolio/DA/PoolAssignment';
import DecisionPending from '../Views/Portfolio/DA/DecisionPending';
import PostDisbursalCaseView from '../Views/Portfolio/PostDisbursalCaseView';
import DaApprovedList from '../Views/Portfolio/DA/DaApprovedList';
import DaFinalList from '../Views/Portfolio/DA/DaFinalList';
import DaPoolSearchResult from '../Views/Portfolio/DA/DaPoolSearchResult';
import BatchListbyId from '../Views/Portfolio/DA/BatchListById/BatchListbyId';
import DOA from '../Views/Portfolio/DOA';
import ChangeCLMType from '../Views/Portfolio/ChangeCLMType';
import CollectionsList from '../Views/Portfolio/Collections/CollectionsList';
import CollectionDetails from '../Views/Portfolio/Collections/CollectionDetails';
import ApiCollectionLogDetails from '../Views/Portfolio/Collections/ApiCollectionLogDetails';
import ColendingListing from '../Views/Portfolio/ColendingLogs/ColendingListing';

export default [
	{
		component: Login,
		path: '/admin/login',
		title: 'login',
		exact: true,
	},
	{
		component: ForgotPassword,
		path: '/admin/password/forget',
		title: 'forgotPassword',
		exact: true,
	},
	{
		component: ResetPassword,
		path: '/admin/password/reset',
		title: 'resetPassword',
		exact: true,
	},
	{
		component: DownloadLink,
		path: '/admin/download',
		title: 'downloadLink',
		exact: true,
	},
	{
		component: ContainerRouter,
		path: '/*',
		title: 'container',
		type: 'admin',
		// exact: true
	},
	{
		component: Dashboard,
		path: '/',
		title: 'dashboard',
		exact: true,
		private: true,
		permission: 'view-dashboard',
	},
	{
		component: NewDashboard,
		path: '/Newdashboard',
		title: 'Newdashboard',
		exact: true,
		private: true,
		permission: 'view-dashboard',
	},
	// {
	// 	component: ManageAffiliate,
	// 	path: '/nsm/approval',
	// 	title: 'manageNSMApproval',
	// 	exact: true,
	// 	private: true,
	// 	listType: 'nsm-partner-list',
	// },
	// {
	// 	component: ManageAffiliate,
	// 	path: '/manage-affiliate',
	// 	title: 'manageAffiliate',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'manage_affiliate',
	// },
	{
		component: ManageRoles,
		path: '/admin/roles',
		title: 'manageRole',
		exact: true,
		private: true,
		permission: 'role-permission-list,view-role-permissions,update-role-permission',
	},
	{
		component: ViewRole,
		path: '/admin/role/add',
		title: 'manageRole',
		exact: true,
		private: true,
		permission: 'add-role-permission',
	},
	{
		component: ViewRole,
		path: '/admin/role/:roleId',
		title: 'manageRole',
		exact: true,
		private: true,
		permission: 'view-role-permissions',
	},
	{
		component: ViewRole,
		path: '/admin/role/edit/:roleId',
		title: 'manageRole',
		exact: true,
		private: true,
		permission: 'update-role-permission',
	},
	{
		component: ManageLeads,
		path: '/manage-leads',
		title: 'manageLeads',
		exact: true,
		private: true,
		permission: 'lead-list',
	},
	// {
	// 	component: AddLead,
	// 	path: '/lead/add',
	// 	title: 'addNewLead',
	// 	exact: true,
	// 	private: true,
	// },
	{
		component: ChangePassword,
		path: '/password/change',
		title: 'changePassword',
		exact: true,
		private: true,
	},
	// {
	// 	component: AddLead,
	// 	path: '/lead/edit/:id',
	// 	title: 'editLead',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'edit-lead',
	// },
	// {
	// 	component: AddLead,
	// 	path: '/lead/:id',
	// 	title: 'leadDetails',
	// 	exact: true,
	// 	private: true,
	// },
	// {
	// 	component: AffiliateKyc,
	// 	path: '/admin/affiliate-kyc/*',
	// 	title: 'affiliateKyc',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'affiliate-detail-kyc',
	// },
	// {
	// 	component: AffiliateKyc,
	// 	path: '/admin/affiliate-kyc/view/:partId',
	// 	title: 'affiliateKyc',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'get-affiliate',
	// },
	// {
	// 	component: AffiliateConfigurationSettings,
	// 	path: '/admin/configure-affiliate/:partId',
	// 	title: 'affiliateConfiguration',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'get-affiliate',
	// },

	// {
	// 	component: ApiDetails,
	// 	path: '/manage-affiliate/api-details/:partId',
	// 	title: 'apiDetails',
	// 	exact: true,
	// 	private: true,
	// },

	{
		component: ManageUsers,
		path: '/admin/manage-users',
		title: 'manageUsers',
		exact: true,
		private: true,
		permission: 'backend-user-list,update-backend-user,view-backend-user',
	},
	{
		component: ViewUser,
		path: '/admin/manage-users/add',
		title: 'addUser',
		exact: true,
		private: true,
		permission: 'add-backend-user',
	},
	{
		component: ViewUser,
		path: '/admin/manage-users/edit/:userId',
		title: 'editUser',
		exact: true,
		private: true,
		permission: 'update-backend-user',
	},

	{
		component: ViewUser,
		path: '/admin/manage-users/:userId',
		title: 'viewUsers',
		exact: true,
		private: true,
		permission: 'view-backend-user',
	},
	// {
	// 	component: ComissionReport,
	// 	path: '/comission-report',
	// 	title: 'comissionReports',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'generate-partner-commission',
	// },

	// {
	// 	component: ComissionReport,
	// 	path: '/comission-report/:partId',
	// 	title: 'comissionReports',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'manage-commission',
	// },
	// {
	// 	component: ManageOffers,
	// 	path: '/offers/:partId',
	// 	title: 'comissionReports',
	// 	exact: true,
	// 	private: true,
	// 	permission: 'list-lead-offer-files',
	// },
	// {
	// 	component: ManageLeads,
	// 	path: '/offers/:partId/leads/:offerId',
	// 	title: 'comissionReports',
	// 	exact: true,
	// 	private: true,
	// },
	{
		component: ConfigureComission,
		path: '/manage-affiliate/cofigure-comission/:partId',
		title: 'comissionReports',
		exact: true,
		private: true,
		permission: 'get-partner-commission-config',
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/assigned',
		title: 'assignedPortfolio',
		exact: true,
		private: true,
		permission: 'get-sanctioned-lead-list',
		customComponentProps: { leadType: 'assigned' },
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/sanction-rejected',
		title: 'sanctionrejectedPortfolio',
		exact: true,
		private: true,
		permission: 'sanction-rejected-lead-list',
		customComponentProps: { leadType: 'rejected' },
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/disbursal-pending',
		title: 'disbursalPendingPortfolio',
		exact: true,
		private: true,
		permission: 'get-disbursal-pending-lead-list',
		customComponentProps: { isOps: true, leadType: 'disbursal-pending' },
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/in-disbursal',
		title: 'disbursalPendingPortfolio',
		exact: true,
		private: true,
		permission: 'get-disbursal-approved-lead-list',
		customComponentProps: { isOps: true, leadType: 'indisbursal-lender-pending' },
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/disbursal-approved',
		title: 'disbursalPendingPortfolio',
		exact: true,
		private: true,
		permission: 'get-disbursed-lead-list',
		customComponentProps: { isOps: true, leadType: 'disbursal-approved' },
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/disbursal-rejected',
		title: 'disbursalRejectedPortfolio',
		exact: true,
		private: true,
		permission: 'get-disbursal-rejected-lead-list',
		customComponentProps: { isOps: true, leadType: 'disbursal-rejected' },
	},
	{
		component: AssignedPortfolio,
		path: '/portfolio/inprincipal-sanction',
		title: 'Inprincipal Sanction',
		exact: true,
		private: true,
		permission: 'inprincipal-lead-list',
		customComponentProps: { leadType: 'inprincipal-sanction' },
	},
	{
		component: UnassignedPortfolio,
		path: '/portfolio/unassigned',
		title: 'unassignedPortfolio',
		exact: true,
		private: true,
		permission: 'get-unassigned-lead-list',
	},
	{
		component: NewDashboard,
		path: '/portfolio/dashboard',
		title: 'portfolioDashboard',
		exact: true,
		private: true,
		permission: 'view-colender-dashboard',
	},
	{
		component: History,
		path: '/portfolio/audit/history',
		title: 'auditHistory',
		exact: true,
		private: true,
	},
	{
		component: BatchHistory,
		path: '/portfolio/audit/history/:batchId',
		title: 'batchAuditHistory',
		exact: true,
		private: true,
	},
	// {
	// 	component: AdditionalInformation,
	// 	path: '/portfolio/unassigned/additional/:id',
	// 	title: 'additionalInformation',
	// 	exact: true,
	// 	private: true
	// },
	{
		component: PendingPortfolio,
		path: '/portfolio/pending',
		title: 'pendingPortfolio',

		private: true,
		permission: 'get-pending-lead-list',
	},
	{
		component: PreApproved,
		path: '/portfolio/pre-approved',
		title: 'preapprovedPortfolio',
		private: true,
		permission: 'get-decision-lead-list',
	},
	{
		component: ViewPortfolio,
		path: '/portfolio/view/:id/*',
		permission: 'details-info,documents,additional-info,queries,drf-info,fundouts,lender-demand,audit-trail',
		private: true,
	},
	{
		component: PendingView,
		path: '/portfolio/pending/:id',
		private: true,
	},
	// {
	// 	component: AddAffiliate,
	// 	path: '/partner/onboarding/add',
	// 	title: 'manageRole',
	// 	exact: true,
	// 	private: true,
	// },
	{
		component: ManageAffiliate,
		path: '/partner/onboarding/status',
		title: 'manageRole',
		exact: true,
		private: true,
		listType: 'pending-affiliate-dsa-list',
	},
	{
		component: ApplicationDetails,
		path: '/onboarding/*',
		private: true,
	},

	{ component: NotFound,path: '/admin/404' },
	{
		component: MisReport,
		path: '/misreport/query',
		title: 'Query',
		// exact: true,
		private: true,
		permission: 'query-mis-reports',
	},
	{
		component: MisReport,
		path: '/misreport/document',
		title: 'Document',
		// exact: true,
		private: true,
		permission: 'documents-availability-mis',
	},
	{
		component: MisReport,
		path: '/misreport/consolidate',
		title: 'Consolidate',
		// exact: true,
		private: true,
		permission: 'consolidate-mis',

	},
	{
		component: MisReport,
		path: '/misreport/bre',
		title: 'BRE',
		// exact: true,
		private: true,
		permission: 'bre-report',

	},
	{
		component: MisReport,
		path: '/misreport/colending',
		title: 'Colending',
		// exact: true,
		private: true,
		permission: 'colending-mis',

	},
	{
		component: MisReport,
		path: '/misreport/utr',
		title: 'UTR',
		// exact: true,
		private: true,
		permission: 'utr-report',

	},
	{
		component: MisReport,
		path: '/misreport/lender',
		title: 'Lender',
		// exact: true,
		private: true,
		permission: 'lender-mis-report',

	},
	{
		component: ApiListing,
		path: '/api-logs/:id',
		title: 'Api Logs List',
		exact: true,
		private: true,
		permission: 'colending-api-logs',

	},
	{
		component: ApiLogDetails,
		path: '/api-logs/:id/:id/:id',
		title: 'Api Logs Detail',
		exact: true,
		private: true,
		permission: 'colending-api-logs',

	},
	{
		component: Fundoutbulkupload,
		path: '/fundout/bulk',
		title: 'fundoutbulk',
		exact: true,
		private: true,
		permission: 'nbfc-fundout-info-upload',
	},
	{
		component: QueryPending,
		path: '/portfolio/query-pending',
		title: 'Query Pending',
		exact: true,
		private: true,
		permission: 'get-query-pending-list',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/machinery',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'machinery-info-upload',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/lap',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'lap-info-upload',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/credit',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'credit-info-upload',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/operations',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'operations-info-upload',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/utr',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'nbfc-fundout-info-upload',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/cersai',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'cersai-info-upload',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/collateral',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'collateral-info-upload',
	},
	{
		component: AdditionalInfoupload,
		path: '/additional-info-upload/collection/:id',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'collection-info-upload',
	},
	{
		component: ApiCollectionLogDetails,
		path: '/collection-logs/:id/:id/:id',
		title: 'Api Collection Logs Detail',
		exact: true,
		private: true,
		permission: 'view-collection-logs',
	},
	{
		component: GlobalSearch,
		path: '/portfolio/global-search',
		title: 'global-search',
		exact: true,
		private: true,
	},
	{
		component: Home,
		path: '/portfolio/home',
		title: 'home',
		exact: true,
		private: true,
		permission: 'home'
	}, 
	{
		component: PostDisbursalCaseView,
		path: '/portfolio/post-disbursal',
		title: 'additional-info-upload',
		exact: true,
		private: true,
		permission: 'post-disbursal-case-view',
	},
	{
		component: ViewPortfolio,
		path: '/portfolio/views/post-disbursal/:id/*',
		exact: true,
		private: true,
		permission: 'repayment-details,repayment-schedule,repayment-soa-documents',
	},
	{
		component: DOA,
		path: '/portfolio/doa',
		exact: true,
		private: true,
		// permission: 'doa',
	},
	{
		component: ChangeCLMType,
		path: '/portfolio/change-clm-type',
		exact: true,
		private: true,
		permission: 'option1to2'
	},
	{
		component: CollectionsList,
		path: '/portfolio/collections',
		exact: true,
		private: true,
		permission: 'view-collections'
	},
	{
		component: CollectionDetails,
		path: '/portfolio/collections/details/:id',
		exact: true,
		private: true,
		permission: 'save-collections'
	},
	{
		component: ColendingListing,
		path: '/colending-logs/:id',
		title: 'Colending Logs List',
		exact: true,
		private: true,
		permission: 'colending-api-logs',

	},
];

